var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isComponentVisible
    ? _c(
        "div",
        [
          _vm.isProcessing
            ? _c("skeleton-pending-actions-slider")
            : _vm.hasPendingActions
            ? _c("slider-container", {
                attrs: {
                  "arrow-style": "circle",
                  "display-arrows": _vm.hasControls,
                  centered: false,
                  "slides-wrapper-class": "gfu-pending-actions-wrapper",
                  "slides-class": "gfu-pending-actions-slides",
                  "data-qa": "pending-actions-slider",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c(
                            "base-title",
                            {
                              staticClass: "_mb-1",
                              attrs: { as: "h2", level: "h2" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.Resources.BackerCenter
                                    .SectionRequiresActionHeader
                                )
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "default",
                      fn: function () {
                        return _vm._l(_vm.pendingActions, function (action) {
                          return _c(
                            "div",
                            {
                              key: action.userPendingActionID,
                              staticClass:
                                "gfu-pending-action gfu-11of12 gfu-3of4--m gfu-1of2--l _shrink-0 _grow-0",
                            },
                            [
                              _c(
                                "notification-action",
                                _vm._b(
                                  {
                                    on: {
                                      "action-dismissed": _vm.onActionDismissed,
                                    },
                                  },
                                  "notification-action",
                                  action,
                                  false
                                )
                              ),
                            ],
                            1
                          )
                        })
                      },
                      proxy: true,
                    },
                    {
                      key: "controls",
                      fn: function ({
                        onScrollLeft,
                        onScrollRight,
                        isOverflownLeft,
                        isOverflownRight,
                      }) {
                        return [
                          _c(
                            "div",
                            [
                              _c(
                                "base-button",
                                {
                                  staticClass: "_ba-0",
                                  attrs: {
                                    theme: "white",
                                    shape: "circle",
                                    shadow: "tight",
                                    "aria-label":
                                      _vm.Resources.Common
                                        .ScrollLeftButtonLabel,
                                    disabled: !isOverflownLeft,
                                    "data-qa": "left-arrow-button",
                                  },
                                  on: { click: onScrollLeft },
                                },
                                [
                                  _c("base-icon", {
                                    staticClass: "_tc--accent",
                                    attrs: { name: "chevron-left", size: "lg" },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "base-button",
                                {
                                  staticClass: "_ba-0",
                                  attrs: {
                                    theme: "white",
                                    shape: "circle",
                                    shadow: "tight",
                                    "aria-label":
                                      _vm.Resources.Common
                                        .ScrollRightButtonLabel,
                                    disabled: !isOverflownRight,
                                    "data-qa": "right-arrow-button",
                                  },
                                  on: { click: onScrollRight },
                                },
                                [
                                  _c("base-icon", {
                                    staticClass: "_tc--accent",
                                    attrs: {
                                      name: "chevron-right",
                                      size: "lg",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3805708052
                ),
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }